<template>
  <div class="home">
    <v-parallax
        dark
        src="../assets/cafe.jpg"
        style="min-height: 650px"
    >
      <v-container>
        <v-row class="text-center">
          <v-col cols="12">
            <v-img
              :src="require('../assets/manducaLogoNegro.jpg.png')"
              class="my-3"
              contain
              height="200"
            />
            <h1 class="display-2 font-weight-bold mb-3">
              Sientete en casa
            </h1>

            <h4 class="subheading font-weight-regular">
              El ingrediente perfecto siempre es el amor  
            </h4>
          </v-col>
        </v-row>
      </v-container>
    </v-parallax>
    <v-app-bar
    color="primary"
    dense
    dark
    fluid
    >
      <marquee-text :repeat="8">
        Horario especial: de Lunes a Sábado de 7:30 hs a 22:00 hs Domingos de 9:00 hs a 15:00 hs
      </marquee-text>
    </v-app-bar>
    <Services />
    <ParallaxImg />
    <ImageList />
    <Coffes />
    <InteractiveImg />
  </div>
</template>

<script>
import ImageList from '@/components/ImageList.vue'
import MarqueeText from 'vue-marquee-text-component'
import Services from '@/components/Services.vue'
import ParallaxImg from '@/components/ParallaxImg.vue'
import InteractiveImg from '@/components/InteractiveImg.vue'
import Coffes from '@/components/Coffes.vue'

export default {
  name: 'Home',
  components: {
    Services,
    ImageList,
    MarqueeText,
    ParallaxImg,
    InteractiveImg,
    Coffes
  }
}
</script>
<style lang="scss" scoped>
  h1 {
    color: black;
  }
  h4 {
    color: black;
  }
</style>
